"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "barbianello": {
    "5510ecfb": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-casonassi": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e13dd3d6": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-nuova": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c5558a8c": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "skipSearch": false
    }],
    "chiarabella": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "329f7a34": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "skipSearch": false
    }],
    "frappetta": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "32dd941d": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "skipSearch": false
    }],
    "fumo": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a57bdb47": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "skipSearch": false
    }],
    "gandiola": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0bb121c1": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "skipSearch": false
    }],
    "gandiolino": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "848edce9": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "skipSearch": false
    }],
    "germot": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ff2fe133": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "skipSearch": false
    }],
    "paglia": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bf73c322": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "skipSearch": false
    }],
    "zerba": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3f6be8a2": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "skipSearch": false
    }],
    "campione": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1bb7207f": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "skipSearch": false
    }],
    "campobianco": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "00d3e73d": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "skipSearch": false
    }],
    "casa-bernini": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ea19e0e5": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "skipSearch": false
    }],
    "casa-brere": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7e1f24f8": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "skipSearch": false
    }],
    "casa-fagioli": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5381bbe4": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "skipSearch": false
    }],
    "casa-novarini": [{
      "hkey": "01c20e43",
      "slug": "barbianello",
      "name": "Barbianello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;